// extracted by mini-css-extract-plugin
export default {"block":"JjRjm","readOnlyBlock":"Am6Mf"};